const actionType = {
  SET_GLOBAL_MODAL_DATA: 'SET_GLOBAL_MODAL_DATA',
  CHANGE_GLOBAL_MODAL_VISIBLE: 'CHANGE_GLOBAL_MODAL_VISIBLE',
}

export default actionType
